import React from 'react';
import { Alert, Icon } from '@seeqdev/qomponents';
import { useTranslation } from 'react-i18next';

export const TableSetupHelp: React.FunctionComponent<{ isTransposed: boolean }> = ({ isTransposed }) => {
  const { t } = useTranslation();

  return (
    <Alert dismissible={false} variant="theme" extraClassNames="min-width-400 fs16 p25 screenshotSizeToContent">
      <Icon icon={!isTransposed ? 'fc-add-column' : 'fc-add-row'} extraClassNames="p5" type="theme" />
      <span> {t(!isTransposed ? 'TABLE_BUILDER.SELECT_COLUMN' : 'TABLE_BUILDER.SELECT_ROW')} </span>
    </Alert>
  );
};
